import {Injectable} from '@angular/core';
import {Routes} from '@angular/router';
import {RouteContext} from './routing/route-context';

@Injectable({providedIn: 'root'})
export class SharedRoutesService {
  private routes = new Map<RouteContext, Routes>();

  set(context: RouteContext, routes: Routes): void {
    this.routes.set(context, routes);
  }

  get(context: RouteContext): Routes {
    return this.routes.get(context) ?? [];
  }
}
